import { SelectOption } from '@g17eco/types/select';

export enum SelectTypes {
  LabelSelect = 'labelSelect',
  SingleSelect = 'singleSelect',
  MultipleSelect = 'multipleSelect',
  CreatableSelect = 'creatableSelect',
  CreatableMultipleSelect = 'creatableMultipleSelect',
}

export type WithString<T> = T | string;

export type Option<T = string | null> = Pick<SelectOption<T>, 'label' | 'searchString' | 'value'> & {
  isDisabled?: boolean;
  tooltip?: string | JSX.Element;
  id?: string;
};

export const SELECT_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'] as const;

export type SelectSize = (typeof SELECT_SIZES)[number];

export interface SelectStyleProps {
  size?: SelectSize;
  isTransparent?: boolean;
  hasOptionDivider?: boolean;
  isFlexibleSize?: boolean;
  showDropdownIndicator?: boolean;
  isMenuPortalTargetBody?: boolean;
  indicateHasReachedLimit?: boolean;
  showCount?: boolean;
  backgroundColor?: 'transparent' | 'var(--theme-BgExtralight)';
  minWidth?: number;
  isInvalid?: boolean;
}
